import { OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { List, ListItem } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { BillableBilling } from './BillableBilling'

type OrganizationFundingProps = {
  org: OrganizationDetailFragment
}
export const OrganizationBilling = ({ org }: OrganizationFundingProps) => {
  return (
    <List>
      <ListItem disableGutters disablePadding>
        <BillableBilling billable={org} billingSource={org.billing?.billingSource} />
      </ListItem>
    </List>
  )
}
